import { render, staticRenderFns } from "./sharepeople.vue?vue&type=template&id=2c311be8&scoped=true"
import script from "./sharepeople.vue?vue&type=script&lang=js"
export * from "./sharepeople.vue?vue&type=script&lang=js"
import style0 from "./sharepeople.vue?vue&type=style&index=0&id=2c311be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c311be8",
  null
  
)

export default component.exports